var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.items),function(item,index){return _c('b-col',{key:index,attrs:{"cols":"12","md":"3"}},[_vm._t("gridView",null,{"item":item})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }